<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

import findIndex from 'lodash/findIndex'
import debounce from 'lodash/debounce'
import { TweenMax as Tween, Power1 } from 'gsap'

import Slide from '@/components/slider/slide'
import Dots from '@/components/dots'
import TransitionWrapper from '@/layout/wrappers/transition-wrapper'


export default {

  name:"sliderMain",

  components:{
    TransitionWrapper,
    Dots,
    Slide
  },

  props:{
    slideList: {
      type: Array,
      default: null
    },
    block: {
      type: Boolean,
      default: false
    }
  },

  data(){
    return{
      currentSlide: 0,
      binded: {}
    }
  },

  mounted () {
    this.getOffset()
    this.binded.onKeypress = this.onKeypress.bind(this)
    document.body.addEventListener('keydown', this.binded.onKeypress)
  },

  beforeDestroy () {
    document.body.removeEventListener('keydown', this.binded.onKeypress)
  },

  computed: {
    slides () {
      const slides = this.$store.state.app.meta.pages
      const filtered = slides.filter(slide => !slide.url.match(/main/))

      const current = findIndex(filtered, slide => !!this.$route.path.match(new RegExp(slide.url)))

      if (current === -1) return filtered

      const sorted = filtered.concat(filtered.splice(0, current + 1))

      return sorted.filter(slide => !this.$route.path.match(new RegExp(slide.url)))
    },

    lang () {
      return this.$route.params.lang
        ? this.$route.params.lang
        : 'ua'
    }
  },

  watch: {
    '$store.state.app.window.width': 'getOffset',
    'offset': 'setActiveSlide',
    'currentSlide': 'setActiveSlide'
  },

  methods: {
    isActive () {
      const bb = this.$el.getBoundingClientRect()
      const hook = bb.bottom - this.$store.state.app.window.height
      const scroll = $store.state.app.window.scroll

      return hook < bb.height / 3
    },

    getSlideIndex: function(){
      this.$emit('slideClick', this.indexSlide);
    },

    onKeypress (event) {
      if (!this.isActive) return

      if (event.keyCode === 37) this.prevSlide()
      if (event.keyCode === 39) this.nextSlide()
      if (event.keyCode === 13) {
        this.$router.push('/' + this.lang + this.slides[this.currentSlide].url)
      }
    },

    scrollUp () {
      if (!this.block) this.$emit('scroll-up')
    },

    prevSlide () {
      if (!this.isActive) return

      if (this.currentSlide === 0) {
        const height = this.$el.offsetHeight
        const scroll = this.$store.state.app.window.scroll - height

        Tween.to(window, 0.5, {
          scrollTo: scroll,
          ease: Power1.easeInOut
        })

        this.scrollUp()
      }

      if (this.block) return

      this.currentSlide = Math.max(this.currentSlide - 1, 0)
    },

    nextSlide: debounce (function () {
      if (!this.isActive || this.block) return

      this.currentSlide = Math.min(this.currentSlide + 1, this.slides.length - 1)
    }, 400, { leading: true, trailing: false }),

    getOffset () {
      this.offset = parseInt(getComputedStyle(this.$refs.slides[0].$el).marginLeft)
    },

    setActiveSlide () {
      const slide = this.$refs.slides[this.currentSlide]
      const offset = slide.$el.offsetLeft - this.offset

      Tween.to(this.$refs.track, 0.5, {
        x: -offset,
        overwrite: 'all',
        ease: Power1.easeInOut
      })
    },

    setSlide(data){
      this.currentSlide = data;
    }
  }
}

</script>

<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

.slider-wrap
  .slider__scrollable(ref="track")
    .slider__track
      slide(
      v-touch:swipedown="scrollUp",
      v-touch:swipeleft="nextSlide",
      v-touch:swiperight="prevSlide",
      @slideClick="setSlide",
      v-for="slide, index in slideList",
      ref="slides",
      :key="index",
      :indexSlide="index",
      :class="{ 'is-active': currentSlide === index }"
      )
        router-link(:to="'/' + lang + slide.url")
          .slide__label(v-if="slide.epigraph") {{ slide.epigraph }}
          h2.slide__title {{ slide.name }}
          .slide__marker.marker
            .marker__bar
            .marker__dot
  transition-wrapper(:appear="true")
    dots.footer-slider__navigation(:items="slideList", :current="currentSlide", :inverted="true")

</template>

<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>
.footer-slider
  position relative
  display flex
  width 100%
  height 100%

  &__main
    width 100%
    height 100%

  &__navigation
    position absolute
    bottom 0
    left 0
    right 0
    margin 0 auto

    +tablet()
      bottom 35px

    +mobile()
      bottom 0px
.slider
  overflow hidden

  &__scrollable
    width 100%
    height calc(100% + 20px)
    display flex
    padding-bottom 20px

  &__track
    display flex
    white-space nowrap
    padding-top 110px

    +mobile()
      padding-top 50px

.slide
  position relative
  display flex
  flex-direction column
  justify-content flex-end
  height 130px
  padding-right 175px
  max-width 894px

  +mobile()
    padding-right 70px
    max-width calc(100vw - 60px)

  &:not(.is-active)

  &:first-child
    margin-left calc((100vw - 894px) / 2)

    +tablet()
      margin-left 45px

    +mobile()
      margin-left 30px

  & + &
    margin-left 75px

    +mobile()
      margin-left 40px

  .is-active~&
      &:before
        content:''
        position: absolute
        top: 0
        left: calc(-75px - 96px)
        height: 100%
        width: 96px
        z-index 2
        cursor: pointer

  &__label
    width 0
    white-space no-wrap
    margin-left 4px
    color dark
    font-weight 500
    font-size 16px
    line-height 23px
    transition opacity .5s, visibility .5s, transform .5s

    .slide:not(.is-active) &
      opacity 0
      visibility hidden
      transform translateY(10px)

    +devices()
      margin-left 0
      font-size 14px

  &__title
    padding-top 30px
    color blue
    font-weight 500
    font-size 86px
    line-height 78px
    white-space nowrap
    transition opacity .5s

    +laptop()
      font-size 76px

    +tablet()
      padding-top 10px
      font-size 60px
      line-height 78px

    +mobile()
      padding-top 15px
      font-size 24px
      line-height 37px

    .slide:not(.is-active) &
      opacity .5

  &__marker
    position absolute
    right 0
    bottom 25px

    +mobile()
      bottom 15px
.marker
  width 96px
  height 24px
  transition opacity .5s

  +mobile()
    width 31px
    height 8px

  .slide:not(.is-active) &
    opacity .25

  &__bar
    z-index 1
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    background-color blue
    transition transform .5s

    .slide:not(.is-active) &
      transform scaleX(0.25)

  &__dot
    z-index 2
    position absolute
    top 0
    left 0
    right 0
    margin 0 auto
    width 24px
    height 24px
    background-color orange

    +mobile()
      width 8px
      height 8px

    .slide.is-active &
      animation marker 2s ease-in-out -1.5s infinite

      +mobile()
        animation markerMob 2s ease-in-out -1.5s infinite

    .slide:not(.is-active) &
      opacity .5

@keyframes marker
  0%
    transform translateX(36px)
  40%
    transform translateX(-36px)
  50%
    transform translateX(-36px)
  90%
    transform translateX(36px)
  100%
    transform translateX(36px)

@keyframes markerMob
  0%
    transform translateX(12px)
  40%
    transform translateX(-12px)
  50%
    transform translateX(-12px)
  90%
    transform translateX(12px)
  100%
    transform translateX(12px)
</style>



// WEBPACK FOOTER //
// slider.vue?6f926e23